export default [{
    path: 'user',
    component: () => import('@/views/organization/user/user'),
}]